/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetPasswordData
 */
export interface ResetPasswordData {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordData
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordData
     */
    cfTurnstileResponse?: string;
}

/**
 * Check if a given object implements the ResetPasswordData interface.
 */
export function instanceOfResetPasswordData(value: object): value is ResetPasswordData {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function ResetPasswordDataFromJSON(json: any): ResetPasswordData {
    return ResetPasswordDataFromJSONTyped(json, false);
}

export function ResetPasswordDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPasswordData {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'cfTurnstileResponse': json['cfTurnstileResponse'] == null ? undefined : json['cfTurnstileResponse'],
    };
}

export function ResetPasswordDataToJSON(json: any): ResetPasswordData {
    return ResetPasswordDataToJSONTyped(json, false);
}

export function ResetPasswordDataToJSONTyped(value?: ResetPasswordData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'cfTurnstileResponse': value['cfTurnstileResponse'],
    };
}

